/**
 * The house carousel arrow: a long shaft with an open chevron head, drawn in
 * one weight with round caps.
 *
 * WHY THIS EXISTS AS A SHARED FILE. The same 74x26 geometry was already living
 * inline in persona-carousel.tsx, and the Claude Code branch pasted a second
 * copy into onprompt-sections.tsx. Two more carousels needed it (mobile reviews,
 * mobile OnPrompt), and a fourth hand-copy of the same four path strings is how
 * they drift: one gets strokeWidth 2 and nobody notices until the arrows sit
 * next to each other. One definition, sized by prop.
 *
 * STROKED IN currentColor, deliberately. These arrows appear on cream, on a
 * near-black OnPrompt room, and on the dark slate reviews room, and each scope
 * sets its own accent. Inheriting the colour means the arrow is correct in all
 * three without a per-scope override; hard-coding --charcoal would have made it
 * invisible in two of them.
 *
 * The viewBox stays 0 0 74 26 whatever the rendered width, so the shaft-to-head
 * proportion is identical to the persona carousel's at every size.
 */
export function DrawnArrow({
  dir,
  width = 46,
}: {
  dir: "prev" | "next";
  /** Rendered width in px. Height follows the 74:26 ratio. The persona carousel
   *  draws it at its native 74; the tighter mobile controls use the default 46. */
  width?: number;
}) {
  return (
    <svg
      width={width}
      height={Math.round((width * 26) / 74)}
      viewBox="0 0 74 26"
      fill="none"
      aria-hidden="true"
    >
      {dir === "prev" ? (
        <>
          <path d="M70 13H4" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" />
          <path
            d="M15 4L4 13L15 22"
            stroke="currentColor"
            strokeWidth="2.25"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ) : (
        <>
          <path d="M4 13H70" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" />
          <path
            d="M59 4L70 13L59 22"
            stroke="currentColor"
            strokeWidth="2.25"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )}
    </svg>
  );
}
